import { render, staticRenderFns } from "./calendar-chart-logs.vue?vue&type=template&id=169c2a1d&"
import script from "./calendar-chart-logs.vue?vue&type=script&lang=js&"
export * from "./calendar-chart-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./calendar-chart-logs-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Fdevel%2Fwidgets%2Fchart%2Fcalendar-chart-logs.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports